<template>
  <el-dialog
    :model-value="visible"
    @update:model-value="$emit('close')"
    title="个人资料"
    width="min(600px, 94vw)"
    :close-on-click-modal="true"
    :destroy-on-close="true"
  >
    <div v-if="profile" class="pc">
      <!-- 头部 -->
      <div class="pc-hd">
        <img :src="profile.avatar || 'https://picsum.photos/id/1005/200'" class="pc-av" alt="">
        <div>
          <div class="pc-nm">{{ profile.nickname || '用户' }}</div>
          <div class="pc-sg" v-if="profile.signature">"{{ profile.signature }}"</div>
        </div>
      </div>
      <div class="pc-bd">
        <div class="pc-r"><span class="pc-l">昵称</span><span class="pc-v">{{ profile.nickname || '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">所在城市</span><span class="pc-v">{{ profile.city || '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">籍贯地</span><span class="pc-v">{{ profile.hometown || '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">职业</span><span class="pc-v">{{ profile.occupation || '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">个性签名</span><span class="pc-v">{{ profile.signature || '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">爱好</span><span class="pc-v">{{ profile.hobbies || '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">身高</span><span class="pc-v">{{ profile.height ? profile.height + 'cm' : '-' }}</span></div>
        <div class="pc-r"><span class="pc-l">体重</span><span class="pc-v">{{ profile.weight ? profile.weight + 'kg' : '-' }}</span></div>
        <div class="pc-r pc-r--c"><span class="pc-l">生活照</span>
          <span v-if="!profile.lifePhotos" class="pc-v">-</span>
          <div v-else class="pc-ph">
            <img v-for="(u, i) in JSON.parse(profile.lifePhotos)" :key="i" :src="u" @click="preview(u)" v-if="JSON.parse(profile.lifePhotos).length">
          </div>
        </div>
        <div class="pc-r"><span class="pc-l">更新于</span><span class="pc-v">{{ profile.updatedTime ? new Date(profile.updatedTime).toLocaleDateString('zh-CN') : '-' }}</span></div>
      </div>
      <div style="padding:8px 20px 16px;text-align:right;font-size:11px;color:#999">{{ JSON.stringify(profile).length }} bytes</div>
    </div>
    <div v-else style="text-align:center;padding:60px;color:#999">加载中...</div>
  </el-dialog>
</template>

<script setup>
import { onMounted } from 'vue'
const props = defineProps({ visible: Boolean, profile: Object })
const emit = defineEmits(['close'])
onMounted(() => { console.log('📸 资料卡片收到的profile:', JSON.stringify(props.profile, null, 2)) })
const preview = (url) => { window.open(url, '_blank') }
</script>

<style scoped>
.pc { font-size: 14px; color: #333; }
.pc-hd { display:flex; align-items:center; gap:14px; padding:20px; background:linear-gradient(135deg,#6C5CE7,#A29BFE); color:#fff; }
.pc-av { width:54px; height:54px; border-radius:50%; object-fit:cover; border:3px solid rgba(255,255,255,0.3); flex-shrink:0; }
.pc-nm { font-size:17px; font-weight:600; }
.pc-sg { font-size:12px; opacity:0.8; margin-top:2px; }
.pc-bd { padding:4px 16px; }
.pc-r { display:flex; padding:10px 0; border-bottom:1px solid #f0f0f0; }
.pc-r:last-child { border-bottom:none; }
.pc-r--c { flex-direction:column; gap:6px; }
.pc-l { width:72px; flex-shrink:0; color:#888; font-size:13px; }
.pc-v { flex:1; word-break:break-word; }
.pc-ph { display:flex; gap:6px; flex-wrap:wrap; }
.pc-ph img { width:72px; height:72px; border-radius:6px; object-fit:cover; cursor:pointer; border:1px solid #eee; }
</style>
